import React from 'react';
import {Form, FormGroup} from 'react-bootstrap';
import { Checkbox } from 'react-icheck';
class CheckEmployeeFilter extends React.Component {

    constructor(...args) {
        super(...args);

        this.state = {}
    }

    onFormChange(e) {
        const {formData} = this.props
        this.props.onChange(!formData)
    }

    render() {
        const {formData,schema} = this.props
        return (        
            <Form inline>
                <FormGroup>
                    <Checkbox
                        checked={formData}
                        onChange={this.onFormChange.bind(this,true)}
                        checkboxClass="icheckbox_square-blue"
                        increaseArea="20%"
                        label={' '+schema.title}
                    >
                    </Checkbox>
                </FormGroup>
            </Form>
        )
    }
}

export default CheckEmployeeFilter;



// WEBPACK FOOTER //
// ./src/view/hr/CheckEmployeeFilter.js